import { POST_LOGIN_REDIRECT_KEY } from '../../constants';
import { normalizePath } from './normalizePath';

/** Remember deep link when an unauthenticated user is sent to the login page. */
export const storePostLoginRedirectIfNeeded = (
  pathname: string,
  search: string,
  home: string,
  setEndpoint: string
): void => {
  const normalizedPath = normalizePath(pathname);
  const normalizedHome = normalizePath(home);
  const normalizedEndpoint = normalizePath(setEndpoint);

  if (
    normalizedPath === normalizedHome ||
    normalizedPath === normalizedEndpoint
  ) {
    return;
  }

  sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, pathname + search);
};
